import React, { useEffect, useState } from "react";
import Logo from "../../../Images/logo192.png";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContractById, updateContract } from "../../../redux/contractSlice/contractSlice";
import notify from "../../../hooks/useNotifaction";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function Contract({ contract = {}, selectedCompany, selectedBranch }) {
  const location = useLocation();
  const { ContractId } = useParams();
  const isContractPage = location.pathname === `/Contracts/Contract/${ContractId}`;
  const isContractAddPage = location.pathname === `/addContract`;
  const dispatch = useDispatch();
  const { detailsContract } = useSelector((state) => state.contract);

  const [contractDetails, setContractDetails] = useState(null);
  const [editedInstallments, setEditedInstallments] = useState([]);
  const [isOffer, setIsOffer] = useState(false); // ✅ لمعرفة إذا كان عرض سعر أو عقد

  useEffect(() => {
    if (isContractPage) dispatch(getContractById(ContractId));
  }, [dispatch, isContractPage, ContractId]);

  useEffect(() => {
    if (detailsContract && isContractPage) {
      console.log(detailsContract);
      setContractDetails(detailsContract);
    } else {
      console.log(contract);
      setContractDetails(contract);
    }
  }, [detailsContract, contract]);

  const handleUpdate = async () => {
    if (!editedInstallments.length) {
      notify("لا توجد بيانات لتحديثها.", "info");
      return;
    }

    const installmentUpdates = [];
    const statusUpdates = [];
    let dueDateUpdate = null;

    editedInstallments.forEach((inst) => {
      const original = contractDetails.payment_installments[inst.installment_number - 1];
      const amountChanged = inst.amount !== original.amount;
      const statusChanged = inst.status !== original.status;
      const dateChanged = inst.due_date && inst.due_date !== original.due_date;

      if (amountChanged) installmentUpdates.push({ installment_number: inst.installment_number, amount: inst.amount });
      if (statusChanged) statusUpdates.push({ installment_number: inst.installment_number, status: inst.status });
      if (dateChanged) dueDateUpdate = { installment_number: inst.installment_number, due_date: inst.due_date };
    });

    const dataPayload = {
      value: Number(contractDetails.value),
      installment_count: contractDetails.payment_installments.length,
    };

    if (installmentUpdates.length) dataPayload.installments_update = installmentUpdates;
    if (statusUpdates.length === 1) dataPayload.payment_status_update = statusUpdates[0];
    if (dueDateUpdate) dataPayload.due_date_update = dueDateUpdate;

    try {
      await dispatch(updateContract({ id: ContractId, data: dataPayload })).unwrap();
      const updated = await dispatch(getContractById(ContractId)).unwrap();
      setContractDetails({ ...updated });
      setEditedInstallments([]);
      notify("تم حفظ التعديلات بنجاح", "success");
    } catch (err) {
      notify(err.message, "error");
    }
  };

  const handlePrintContract = () => {
    document.body.classList.remove("offer-print");
    setTimeout(() => window.print(), 100);
  };


const handlePrintOffer = () => {
  // 🟢 الخطوة 1: نحفظ العناصر اللي هنتعامل معها
  const titleContract = document.querySelector(".title-contract");
  const pageTitle = document.querySelector(".page-title");
  const introLine = document.querySelector(".intro-line");

  // 🟢 الخطوة 2: نخزن النصوص الأصلية
  const originalTitle = titleContract?.textContent;
  const originalPageTitle = pageTitle?.textContent;

  // 🟢 الخطوة 3: نغيّر النصوص ونخفي السطر
  if (titleContract) titleContract.textContent = "عرض سعر";
  if (pageTitle) pageTitle.textContent = "عرض سعر";
  if (introLine) introLine.style.display = "none";

  // 🟢 الخطوة 4: نطبع
  setTimeout(() => {
    window.print();

    // 🟢 الخطوة 5: نرجع النصوص بعد الطباعة
    if (titleContract) titleContract.textContent = originalTitle;
    if (pageTitle) pageTitle.textContent = originalPageTitle;
    if (introLine) introLine.style.display = "";
  }, 100);
};

  const filteredTerms = contractDetails?.terms?.filter((term) => term.title !== "main") || [];
  const mainTerms = contractDetails?.terms?.filter((term) => term.title === "main") || [];

  return (
    <div className={isContractPage ? "main" : "container-fluid"}>
      <h1 className="mb-3 text-white print-hide page-title">عقد شركة أرامكو للبترول</h1>
      <div className="container22">
        <div className="card">
          {isContractPage && (
            <div className="card-header text-end print-hide">
              <button className="btn btn-primary me-2" onClick={handlePrintContract}>
                طباعة عقد
              </button>
              <button className="btn btn-success" onClick={handlePrintOffer}>
                طباعة عرض سعر
              </button>
            </div>
          )}

          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-12">
                <div className="print-   py-3 mb-2">
                  <div className="logo d-flex mb-3 align-items-center ">
                    <figure className="me-3 mb-0">
                      <img src={Logo} alt="logo" style={{ height: "70px" }} />
                    </figure>
                    <div>
                      <h1 className="h6 mb-0 text-start">بصمة خبرة لأدوات الأمن والسلامة</h1>
                      <h1 className="h6 mb-0 text-start">Experience Mark For Safety & Security Tools</h1>
                      <p className="mb-0 fs-5 text-start" dir="ltr">
                        Supply ,Installation & Maintenance توريد وتركيب وصيانة
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4  mx-auto text-center">
                <h4 className="title-contract contract-type-title">عقد صيانة</h4>
                <h5>
                  {!isOffer && "رقم العقد"} {contractDetails?.contract_number}
                </h5>
              </div>
              {/* <div className="col-md-4 text-end">
                  <img src={Logo} alt="logo" className="contract-logo" />
                </div> */}
            </div>

            <div className="">
              <p className="intro-line">
                تم بعون الله وتوفيقه إبرام هذا {isOffer ? "العرض" : "العقد"} في {contractDetails?.start_date} بين كلا من :-
              </p>

              <div className="d-flex justify-content-between">
                <p>{contractDetails?.name || `شركة ${selectedCompany?.label || contractDetails?.branch?.company?.name} فرع ${selectedBranch?.label || contractDetails?.branch?.name}`}</p>
                <p>(يشار اليها فيما يلي بالطرف الأول)</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>مؤسسة بصمة خبرة لأدوات ومواد السلامة</p>
                <p>(يشار اليها فيما يلي بالطرف الثاني)</p>
              </div>
            </div>

            <div className="">
              <h5>تمهيد</h5>
              <p>{contractDetails?.introduction || "لا يوجد تمهيد."}</p>
            </div>

            <div className="row justify-content-between ">
              <div className="col-md-4 col-sm-6">
                <h5>المدة:</h5>
                <p>
                  من {contractDetails?.start_date} حتى {contractDetails?.end_date}
                </p>
              </div>
              <div className="col-md-4 col-sm-6">
                <h5>القيمة:</h5>
                <p>{contractDetails?.value} ريال سعودي</p>
              </div>
              <div className="col-md-4 col-sm-6">
                <h5>عدد الزيارات:</h5>
                <p>{contractDetails?.maintenance_visits} زيارة</p>
              </div>
              <div className="col-md-4 col-sm-6">
                <h5>طريقة الدفع:</h5>
                <p>{contractDetails?.payment_type === "full" ? "نقدي" : "أقساط"}</p>
              </div>
            </div>

            {contractDetails?.payment_type === "installments" && !isContractAddPage && !isOffer && (
              <>
                <div className="mx-5 col-md-4 col-sm-6 mt-5 print-hide">
                  <h5>دفعات التقسيط:</h5>
                </div>
                <table className="table table-bordered text-center align-middle print-hide">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>المبلغ (ر.س)</th>
                      <th>تاريخ الاستحقاق</th>
                      <th>حالة الدفع</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contractDetails.payment_installments?.length > 0 ? (
                      contractDetails.payment_installments.map((installment, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{installment.amount}</td>
                          <td>{installment.due_date}</td>
                          <td>{installment.status === "paid" ? "مدفوع" : "غير مدفوع"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">لا توجد دفعات حالياً.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}

            {/* {mainTerms?.length > 0 && (
              <>
                <div className="mx-5 col-md-4 col-sm-6 mt-5">
                  <h5>البنود الرئيسية:</h5>
                </div>
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>البند</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mainTerms.length > 0 ? (
                      mainTerms.map((term, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-start">{term.description}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">لا توجد بنود حالياً.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )} */}
            {contractDetails?.clauses?.length > 0 && (
              <>
                <div className="mx-5 col-md-4 col-sm-6 mt-5" style={{ marginTop: "30px" }}>
                  <h5>مفردات الصيانة :</h5>
                </div>
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>البند</th>
                      <th>الكمية</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contractDetails?.clauses.length > 0 ? (
                      contractDetails?.clauses.map((clause, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-start">{clause.item}</td>
                          <td className="text-start">{clause?.quantity}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3">لا توجد بنود حالياً.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}

            {contractDetails?.terms?.length > 0 && (
              <div>
                <h5>بنود العقد:</h5>
                <ol>
                  {contractDetails?.terms?.length > 0 ? (
                    contractDetails?.terms?.map((term, index) => (
                      <li key={index}>
                        <p>{term.description}</p>
                      </li>
                    ))
                  ) : (
                    <p>لا توجد بنود حالياً.</p>
                  )}
                </ol>
              </div>
            )}

            <div className="row">
              <div className="col-6 text-center">
                <p className="h5">الطرف الأول</p>
                <p>التوقيع</p>
                <p>الختم</p>
              </div>
              <div className="col-6 text-center">
                <p className="h5">الطرف الثاني</p>
                <p>التوقيع</p>
                <p>الختم</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
